import { render, staticRenderFns } from "./open-quotations.vue?vue&type=template&id=161e262e&scoped=true&"
import script from "./open-quotations.vue?vue&type=script&lang=js&"
export * from "./open-quotations.vue?vue&type=script&lang=js&"
import style0 from "./open-quotations.vue?vue&type=style&index=0&id=161e262e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e262e",
  null
  
)

export default component.exports